<template>
  <v-divider
    color="grey-100"
    opacity="1"
    class="my-0 py-0"
  />
</template>
<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: 'AppListDivider',
})

</script>